export const Logo = () => {
    return <img src="/order-assist.svg" alt="" style={{width: '100%'}}/>;
};
